import Rollbar from "rollbar";

const accessToken = process.env.NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN;

const clientConfig: Rollbar.Configuration = {
  accessToken,
  captureUncaught: false,
  captureUnhandledRejections: false,
  environment: process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.NODE_ENV,
  enabled: process.env.NODE_ENV !== "development",
  payload: {
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
      },
    },
  },
};

let rollbar: Rollbar | undefined;

export const getRollbar = (): Rollbar => {
  if (!rollbar) {
    rollbar = new Rollbar(clientConfig);
  }
  return rollbar;
};

export const reportErrorToRollbar = (
  error: Error & { digest?: string },
): void => {
  if (typeof window === "undefined") {
    return;
  }

  if (!accessToken) {
    console.error("Rollbar: NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN is not set");
    return;
  }

  getRollbar().error(error, { digest: error.digest }, (err, data) => {
    if (err) {
      console.error("Rollbar report failed", err);
      return;
    }
    console.info("Rollbar report ok", data);
  });
};
